<template>
  <div class="background">
    <div class="container">
      <div class="popup">
        <div class="text-container">
          <!-- <div class="text-first">
            {{ getTranslatedString('age_gate_welcome') }}
          </div> -->
          <div class="text-second">
            {{ getTranslatedString('age_gate_welcome_desc') }}
          </div>
          <div class="result-container">
            <div class="result-background">
              <div class="result-text">
                {{ date }}
              </div>
            </div>
          </div>
          <div class="info">
            {{ getTranslatedString('info_not_saved') }}
          </div>
        </div>
        <div class="pad-container">
          <div
            :class="['close-container', {
              'close-container-focus': posFocus == -3
            }]"
            @click="close"
          ></div>
          <div class="button">
            <AgeSettingNumber
              v-for="num in numbers" :key="num"
              v-on:add_number="addNumber"
              v-on:remove_number="removeNumber"
              :val="num" :posFocus="posFocus"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AgeSettingNumber from '@/components/AgeSettingNumber.vue';
  import SettingStorage from '@/utils/settings.storage';
  import { soundList, soundPlayer } from '@/utils/sounds';
  import { itemList } from '@/utils/settings.options';
  import langUtil, { StringKey } from '@/utils/lang.util';

  export default {
    components: { AgeSettingNumber },
    data() {
      return {
        numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, -1, 0, -2],
        date: 'AAAA',
        count: 0,
        posFocus: -5
      };
    },
    computed: {
      isAgeSettingDisplayed() {
        return this.$store.getters['settings/isAgeSettingDisplayed'];
      },
      ageSettingPath() {
        return this.$store.getters['settings/ageSettingPath'];
      },
    },
    methods: {
      setVideoIsPaused() {
        this.$store.dispatch('settings/setVideoIsPaused');
      },
      displayAgeSetting() {
        this.$store.dispatch('settings/displayAgeSetting');
      },
      setTimeLimit(limit) {
        this.$store.dispatch('settings/setTimeLimit', limit);
      },
      setFocusSettings() {
        this.$store.dispatch('settings/setFocusSettings');
      },
      handleKeyboard(event) {
        // event.preventDefault();
        if (this.isAgeSettingDisplayed) {
          try {
            switch (event.keyCode) {
              case VK_LEFT: {
                if (this.posFocus === -1) {
                  this.posFocus = 0;
                } else if (this.posFocus > 0) {
                  this.posFocus--;
                } else if (this.posFocus === 0) {
                  this.posFocus = -3;
                }
                break;
              }
              case VK_RIGHT: {
                if (this.posFocus === -1) {
                  this.posFocus = 0;
                } else if (this.posFocus >= 0 && this.posFocus < 10) {
                  this.posFocus++;
                } else if (this.posFocus === -3) {
                  this.posFocus = 0;
                }
                break;
              }
              case VK_UP: {
                if (this.posFocus === -1) {
                  this.posFocus = 0;
                } else if (this.posFocus > 2 && this.posFocus < 9) {
                  this.posFocus -= 3;
                } else if (this.posFocus === 9) {
                  this.posFocus = 7;
                } else if (this.posFocus === 10) {
                  this.posFocus = 8;
                } else {
                  this.posFocus = -3;
                }
                break;
              }
              case VK_DOWN: {
                if (this.posFocus === -1) {
                  this.posFocus = 0;
                } else if (this.posFocus < 7) {
                  this.posFocus += 3;
                } else if (this.posFocus === 7 || this.posFocus === 6) {
                  this.posFocus = 9;
                } else if (this.posFocus === 8) {
                  this.posFocus = 10;
                }
                break;
              }
              case VK_ENTER: {
                if (this.posFocus === -1) {
                  this.posFocus = 0;
                } else if (this.posFocus === 9) {
                  this.addNumber(0);
                } else if (this.posFocus === 10) {
                  this.removeNumber();
                } else if (this.posFocus === -3) {
                  this.reset();
                  this.close();
                } else {
                  this.addNumber(this.posFocus + 1);
                }
                break;
              }
              case VK_BACK:
              case VK_BACK_SPACE: {
                this.close();
              }
              case VK_0: {
                this.addNumber(0);
                break;
              }
              case VK_1: {
                this.addNumber(1);
                break;
              }
              case VK_2: {
                this.addNumber(2);
                break;
              }
              case VK_3: {
                this.addNumber(3);
                break;
              }
              case VK_4: {
                this.addNumber(4);
                break;
              }
              case VK_5: {
                this.addNumber(5);
                break;
              }
              case VK_6: {
                this.addNumber(6);
                break;
              }
              case VK_7: {
                this.addNumber(7);
                break;
              }
              case VK_8: {
                this.addNumber(8);
                break;
              }
              case VK_9: {
                this.addNumber(9);
                break;
              }
            }
          } catch (error) {
            switch (event.key) {
              case '0': {
                this.addNumber(0);
                break;
              }
              case '1': {
                this.addNumber(1);
                break;
              }
              case '2': {
                this.addNumber(2);
                break;
              }
              case '3': {
                this.addNumber(3);
                break;
              }
              case '4': {
                this.addNumber(4);
                break;
              }
              case '5': {
                this.addNumber(5);
                break;
              }
              case '6': {
                this.addNumber(6);
                break;
              }
              case '7': {
                this.addNumber(7);
                break;
              }
              case '8': {
                this.addNumber(8);
                break;
              }
              case '9': {
                this.addNumber(9);
                break;
              }
              case 'Backspace': {
                this.removeNumber();
                break;
              }
            }
          }
        }
      },
      getSplitDate() {
        const actualDate = this.date;
        const actualDateArray = actualDate.split('');
        return actualDateArray;
      },
      getTranslatedString(string){
        return langUtil.getLang().t(string)
      },
      addNumber(value) {
        const dateArray = this.getSplitDate();

        dateArray [this.count] = value;
        this.date = dateArray.join('');
        this.count++;

        if (this.count === 4) {
          const now = new Date();
          const allowedBirthdate = now.getFullYear() - 18;
          const birthDate = Number(this.date);

          try {
            if (VK_1) {
              this.posFocus = -1;
            }
          } catch (error) {
            // Empty block to detect vewd TV
          }

          if (birthDate <= allowedBirthdate && birthDate >= 1900) {
            if (this.$route.name === 'player') {
              this.setVideoIsPaused(false);
              this.reset();
              this.$router.push({ name: 'settings' });
            } else {
              if (this.ageSettingPath === 'settings') {
                this.$router.push({ name: 'settings' });
              } else {
                this.$router.push({ name: 'search' });
              }
              this.close();
            }
          } else {
            this.$store.dispatch("settings/setNotificationVisibility", {
              status: true,
              title: 'text_oops',
              message: 'video_selection_toast_too_young',
              closeButton: true
            });
            this.close();
          }
        }
      },
      removeNumber() {
        const dateArray = this.getSplitDate();
        let count = 0;

        dateArray.every((x) => {
            if (!isNaN(x)) {
              count++;
              return true;
            } else {
              return false;
            }
          },
        );

        dateArray[count - 1] = 'A';
        this.date = dateArray.join('');
        this.count = count - 1;
      },
      close() {
        soundPlayer(soundList.general);
        if (this.$route.name === 'player') {
          this.$router.push({ name: 'home' });
        }
        this.reset();
      },
      reset() {
        this.date = 'AAAA';
        this.count = 0;

        try {
          if (VK_1) {
            this.posFocus = -1;
          }
        } catch (error) {
          // Empty block to detect vewd TV
        }

        this.displayAgeSetting(false);
      },
    },
    mounted() {
      try {
        if (VK_1) {
          this.posFocus = -1;
        }
      } catch (error) {
        // Empty block to detect vewd TV
      }
      document.addEventListener('keyup', this.handleKeyboard);
    },
    destroyed() {
      document.removeEventListener('keyup', this.handleKeyboard);
    },
  };
</script>

<style lang="scss" scoped>
  .background {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    z-index: 200;
    justify-content: center;
    justify-items: center;
    align-items: center;

    .container {
      position: relative;
      width: 84vw;
      max-width: 1200px;
      display: flex;
      flex-direction: column;
      margin: 10%;
      background-color:#020076;
      background-position: center;
      background-size: cover;
      border: 6px solid #fff;
      border-radius: 40px;

      &::before {
        content: '';
        display: block;
        padding-top: 59.32%;
      }

      @media (min-width: 1024px) {
        max-height: 95%;
        max-width: 65%;
      }

      @media (max-width: 768px) {
        height: auto;
        max-height: unset;

        &::before {
          display: none;
        }
      }

      @media (max-width: 420px) and (orientation: portrait) {
        width: 82vw;
        max-height: unset;
        max-width: unset;
        border-radius: 22px;
        border-width: 3px;
      }

      @media (max-height: 480px) {
        max-width: 525px;
        border-radius: 22px;
        border-width: 3px;
        max-height: 95%;
      }

      .popup {
        display: flex;
        flex: 1;
        flex-direction: row;
        position: absolute;
        top: 0;
        left: 0; 
        right: 0;
        bottom: 0; 

        @media (max-width: 768px) {
          display: block;
          position: relative;
        }

        @media (max-height: 480px) {
          display: flex;
          flex-direction: row;
        }
      }

      .text-container {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        margin: 40px 0 40px 40px;

        @media (max-width: 768px) {
          width: 100%;
          text-align: center;
          margin: 0;
          padding: 40px 40px 10px;
          display: block;
          box-sizing: border-box;
        }

        @media (max-width: 420px) {
          padding: 40px 25px 0px;
          text-align: left;
        }

        @media (max-height: 480px) {
          text-align: left;
          margin: 25px 0 10px 10px;
          padding: 20px;
          flex: unset;
          width: 50%;
        }
      }

      .text-first {
        font-family: 'Nunito-ExtraBold', serif;
        color: #fff;
        font-size: 24px;

        @media (min-width: 1090px) {
          margin-top: 5%;
          font-size: 4em;
        }

        @media (max-width: 768px) {
          font-size: 22px;
        }

        @media (max-height: 480px) {
          font-size: 20px;
        }
      }

      .text-second {
        font-family: 'Nunito-Regular', serif;
        color: #fff;
        font-size: 20px;
        margin-top: 8px;
        line-height: 1.6;

        @media (min-width: 1090px) {
          font-size: 2em;
        }

        @media (max-width: 768px) {
          font-size: 18px;
        }

        @media (max-height: 480px) {
          font-size: 16px;
        }
      }

      .result-container {
        margin-top: 20px;
        margin-bottom: 20px;

        @media (max-width: 768px) {
          margin-top: 10px;
          margin-bottom: 10px;
        }

        @media (max-width: 420px) {
          margin-top: 10px;
          margin-bottom: 10px;
        }

        @media (max-height: 480px) {
          margin-top: 15px;
          margin-bottom: 15px;
        }
      }

      .result-background {
        display: inline-block;
        background-color: #fff;
        margin: auto;
        padding: 10px 40px;
        border-radius: 20px;

        @media (max-width: 320px), (max-height: 320px) {
          padding: 10px 25px;
        }

        @media (max-width: 420px) and (orientation: portrait) {
          padding: 10px 20px;
          border-width: 2px;
        }

        @media (max-height: 420px) {
          padding: 10px 20px;
          border-width: 2px;
        }
      }

      .result-text {
        color: rgba(2, 0, 118, 0.6);;
        font-size: 25px;
        font-family: 'Nunito-Regular', Arial, sans-serif;
        font-weight: 600;
        letter-spacing: 5px;
        margin-right: -2px;
        text-align: center;
        white-space: nowrap;

        @media (max-width: 768px) {
          font-size: 36px;
        }

        @media (max-height: 480px) {
          font-size: 22px;
        }

        @media (max-width: 480px) {
          font-size: 22px;
        }
      }

      .info {
        font-family: 'Nunito-Regular', Arial, sans-serif;
        font-size: 16px;
        margin-bottom: 0;
        color: #fff;
        opacity: 0.8;

        @media (min-width: 1090px) {
          font-size: 1.6em;
        }

        @media (max-width: 420px), (max-height: 420px) {
          font-size: 14px;
        }

        @media (max-width: 320px), (max-height: 320px) {
          font-size: 13px;
        }

        @media (max-width: 420px) and (orientation: portrait) {
          text-align: left;
          font-size: 13px;
          margin-bottom: 25px;
        }
      }

      .close-container {
        width: 60px;
        height: 60px;
        margin-left: auto;
        margin-right: 10px;
        cursor: pointer;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('@/assets/icons/close.svg');

        @media (min-width: 1090px) {
          width: 22%;
          height: 14%;
          margin-bottom: 10px;
        }

        @media (max-width: 768px) {
          position: absolute;
          top: 10px;
          right: 0px;
        }

        @media (max-width: 420px) {
          width: 40px;
          height: 40px;
        }

        @media (max-height: 480px) {
          position: absolute;
          top: 10px;
          right: 20px;
          width: 40px;
          height: 40px;
        }
      }

      .close-container-focus {
        transform: scale(1.1);
      }

      .pad-container {
        margin: 20px 20px 20px 0;
        flex: 1;
        display: flex;
        flex-direction: column;

        @media (max-width: 768px) {
          display: block;
          width: 75%;
          box-sizing: border-box;
          margin: 10px auto;
          max-width: 240px;
        }

        @media (max-width: 425px) {
          max-width: 210px;
        }

        @media (max-height: 480px) {
          width: 50%;
          margin: 50px 0px auto auto;
        }
      }

      .button {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        width: 77%;
        margin: auto 0px auto auto;

        @media (max-width: 768px) {
          margin: auto;
        }

        @media (max-height: 480px) {
          max-height: 80%;
          max-width: 170px;
          margin-left: auto;
          margin-right: 20px;
          margin-top: 10px;
        }

        @media (max-height: 290px) {
          max-width: 135px;
        }

        @media (max-width: 480px) {
          width: 82%;
          margin-top: 10px;
        }
      }
    }
  }
</style>